import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="py-16 bg-stone-950 border-t border-stone-800" data-id="element-969">
      <div className="max-w-6xl mx-auto px-6" data-id="element-970">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16" data-id="element-971">
          {/* Brand */}
          <div className="md:col-span-4" data-id="element-972">
            <p className="font-serif text-xl text-stone-50 mb-4" data-id="element-973">BlockQuote</p>
            <p className="text-stone-400 max-w-sm leading-relaxed" data-id="element-974">
              Instant group quotes. One-click holds. Direct resort pricing. The
              infrastructure layer for group travel.
            </p>
          </div>

          {/* Platform */}
          <div className="md:col-span-2" data-id="element-975">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-976">
              Platform
            </p>
            <ul className="space-y-3" data-id="element-977">
              <li data-id="element-978">
                <button onClick={() => scrollTo('features')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-979">
                  Product
                </button>
              </li>
              <li data-id="element-980">
                <button onClick={() => scrollTo('pricing')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-981">
                  Pricing
                </button>
              </li>
              <li data-id="element-982">
                <button onClick={() => scrollTo('proof')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-983">
                  Case Study
                </button>
              </li>
            </ul>
          </div>

          {/* Demos */}
          <div className="md:col-span-3" data-id="element-984">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-985">
              Live Demos
            </p>
            <ul className="space-y-3" data-id="element-986">
              <li data-id="element-987">
                <Link to="/app" className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-988">
                  Resort Dashboard
                </Link>
              </li>
              <li data-id="element-989">
                <Link to="/agency" className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-990">
                  Agency Portal
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div className="md:col-span-3" data-id="element-991">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-992">
              Company
            </p>
            <ul className="space-y-3" data-id="element-993">
              <li data-id="element-994">
                <Link to="/deck" className="text-stone-400 hover:text-stone-50 transition-colors text-sm inline-flex items-center gap-2" data-id="element-995">
                  Pitch Deck
                </Link>
              </li>
              <li data-id="element-996">
                <Link to="/sales" className="text-stone-400 hover:text-stone-50 transition-colors text-sm inline-flex items-center gap-2" data-id="element-997">
                  Resort Sales Deck
                  <span className="font-mono text-[10px] text-red-600 border border-red-600/30 px-1.5 py-0.5" data-id="element-998">
                    NEW
                  </span>
                </Link>
              </li>
              <li data-id="element-999">
                <Link to="/onboarding/lomas" className="text-stone-400 hover:text-stone-50 transition-colors text-sm inline-flex items-center gap-2" data-id="element-1000">
                  Lomas Onboarding
                  <span className="font-mono text-[10px] text-emerald-500 border border-emerald-500/30 px-1.5 py-0.5" data-id="element-1001">
                    PILOT
                  </span>
                </Link>
              </li>
              <li data-id="element-1002">
                <button onClick={() => scrollTo('cta')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-1003">
                  Request Pilot
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-stone-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4" data-id="element-1004">
          <p className="font-mono text-xs text-stone-500" data-id="element-1005">
            © 2026 BlockQuote. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-1006">
            <span className="font-mono text-xs text-stone-500 hover:text-stone-400 cursor-pointer transition-colors" data-id="element-1007">
              Privacy
            </span>
            <span className="font-mono text-xs text-stone-500 hover:text-stone-400 cursor-pointer transition-colors" data-id="element-1008">
              Terms
            </span>
          </div>
        </div>
      </div>
    </footer>;
}